export var SurfaceType;
(function (SurfaceType) {
    SurfaceType["Wall"] = "wall";
    SurfaceType["Ceiling"] = "ceiling";
    SurfaceType["Floor"] = "floor";
})(SurfaceType || (SurfaceType = {}));
